__webpack_require__.p = "/wp-data/plugins/e3dc-configurator/configurator/";